import { useState, useEffect } from "react";
import { useApiCall } from "./useApiCall";

export const useReviewVote = () => {
  const [reviewUpVote, setReviewUpVote] = useState();
  const [reviewUpVoteError, setReviewUpVoteError] = useState();
  const [reviewUpVoteStatus, setReviewUpVoteStatus] = useState("idle");
  const [reviewDownVote, setReviewDownVote] = useState();
  const [reviewDownVoteError, setReviewDownVoteError] = useState();
  const [reviewDownVoteStatus, setReviewDownVoteStatus] = useState("idle");
  const [isUpVoting, setIsUpVoting] = useState(false);
  const [isDownVoting, setIsDownVoting] = useState(false);

  const { executeApiCall, apiCallResponse, apiCallStatus } = useApiCall();

  const reset = () => {
    setReviewUpVote();
    setReviewDownVote();

    setReviewUpVoteError();
    setReviewDownVoteError();

    setReviewUpVoteStatus("idle");
    setReviewDownVoteStatus("idle");

    setIsDownVoting(false);
    setIsUpVoting(false);
  };

  const upVoteReview = (reviewId) => {
    let url = `/reviews/${reviewId}/vote`;

    const requestOptions = {
      url,
      method: "PUT",
      data: {
        upVote: true,
      },
    };

    executeApiCall(requestOptions);

    reset();

    setIsUpVoting(true);

    setReviewUpVoteStatus("pending");
  };

  const downVoteReview = (reviewId) => {
    let url = `/reviews/${reviewId}/vote`;

    const requestOptions = {
      url,
      method: "PUT",
      data: {
        downVote: true,
      },
    };

    executeApiCall(requestOptions);

    reset();

    setIsDownVoting(true);

    setReviewDownVoteStatus("pending");
  };

  useEffect(() => {
    switch (apiCallStatus) {
      case "success": {
        if (apiCallResponse.data.data) {
          if (isUpVoting) {
            setReviewUpVote(true);
            setReviewUpVoteStatus("ready");
          }

          if (isDownVoting) {
            setReviewDownVote(true);
            setReviewDownVoteStatus("ready");
          }
        } else {
          if (isUpVoting) {
            setReviewUpVoteError(apiCallResponse.data.error.userMessage);
            setReviewUpVoteStatus("ready");
          }

          if (isDownVoting) {
            setReviewDownVoteError(apiCallResponse.data.error.userMessage);
            setReviewDownVoteStatus("ready");
          }
        }

        setIsUpVoting(false);
        setIsDownVoting(false);

        break;
      }

      case "error": {
        if (isUpVoting) {
          setReviewUpVoteStatus("ready");
        }

        if (isDownVoting) {
          setReviewDownVoteStatus("ready");
        }

        setIsUpVoting(false);
        setIsDownVoting(false);

        break;
      }
    }
  }, [apiCallStatus, apiCallResponse]);

  return {
    reviewUpVote,
    reviewUpVoteError,
    reviewUpVoteStatus,
    reviewDownVote,
    reviewDownVoteError,
    reviewDownVoteStatus,
    isUpVoting,
    isDownVoting,
    upVoteReview,
    downVoteReview,
  };
};
